import { RecurrentBody } from "@/backend/domains/payment-system/infrastructure/tiptop";
import { PayOptions, PaymentModalApi } from "../../../domain/types";
import { TiptopPayOptions, TiptopWidget } from "./types";

//

export class TiptopPaymentModalApi implements PaymentModalApi {
  constructor(
    private instance: TiptopWidget,
    private publicId: string,
    private organizationId: string,
  ) {}

  //

  public createChargeModal(options: PayOptions) {
    return this.instance.pay("charge", this.createOptions(options));
  }

  //

  public createAuthModal(options: PayOptions) {
    return this.instance.pay("auth", this.createOptions(options));
  }

  //

  private createOptions(options: PayOptions): TiptopPayOptions {
    const { invoice } = options;
    const data = invoice.data;

    const recurrent =
      data.type === "subscription"
        ? ({
            Interval: data.interval,
            Period: data.period,
            Amount: data.amount,
            StartDate: data.startDate,
          } satisfies RecurrentBody)
        : null;

    return {
      currency: "KZT",
      publicId: this.publicId,
      accountId: this.organizationId,
      requireEmail: false,
      amount: invoice.amount,
      description: invoice.description,
      invoiceId: invoice.id,
      data: recurrent ? { PaymentData: { recurrent } } : {},
    };
  }
}
